import Cookies from 'js-cookie'
import {login, logout, getInfo} from '@/api/login'

// 在vue 页面引用  this.$store.state.user.info.name
// this.$store.state.user.token
const state = {
  info: {
    name: "系统管理员"
  },
  // 功能权限
  permissions: [],
  //菜单
  menu: [],
  //token
  token: Cookies.get("user.token") || ""
}
const mutations = {
  SET_USERINFO: (state, user) => {
    state.info = user
  },
  SET_PERMISSIONS: (state, permission) => {
    state.permissions = permission
  },
  SET_MENU: (state, menu) => {
    state.menu = menu
  }
}

const actions = {
  // 获取用户信息
  GetInfo: function ({commit, state}) {
    return new Promise((resolve, reject) => {
      // 传项目id过去，则会根据项目查其所有菜单及权限
      getInfo().then(response => {
        console.log(response)
        const user = response.data.user
        // commit('SET_NAME', user.name)
        commit('SET_USERINFO', response.data.user)
        commit('SET_PERMISSIONS', response.data.permission)
        commit('SET_MENU', response.data.menu)

        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 登出
  LogOut: function ({commit, state}) {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()
    setCookie('platform', '', {domain: location.hostname, path: location.pathname})
    return new Promise((resolve, reject) => {
      logout(state.token).then((data) => {
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}